import { render } from "./returnPoints.vue?vue&type=template&id=b4951bc2&scoped=true"
import script from "./returnPoints.vue?vue&type=script&lang=js"
export * from "./returnPoints.vue?vue&type=script&lang=js"

import "./returnPoints.vue?vue&type=style&index=0&id=b4951bc2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4951bc2"]])

export default __exports__